//课中活动测验
export const TEST_LIST = 'test_list'
export const TEST_INFO = 'test_info'